import React, { Component } from 'react'
import {
  PageWrapper,
  FormikForm,
  SelectBox,
  Button,
  TextField,
  XXLText,
  Header,
  Datepicker,
  Modal,
  DefaultText,
  StyledImage,
  FlexWrapper,
  Radio,
  Checkbox,
  MySelectCheckbox,
  TextArea,
  Card
} from '../components'
import styled from 'styled-components'
import { Formik, Field } from 'formik'
import 'react-table/react-table.css'
import { get, values, isEmpty, uniqBy } from 'lodash'
import axios from 'axios'
import { API_URL } from '../constants'
import moment from 'moment'
import { components } from 'react-select'
import { changeUpcValidator } from '../utlis/validators'
const Close = styled.div`
  border: 1px solid red;
  color: red;
  width: 20px;
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  height: 20px;
  border-radius: 50%;
  &:hover {
    background: red;
    color: #fff;
  }
`

const usStates = [
  {
    label: 'Alaska (AK)',
    value: 'Alaska'
  },
  {
    label: 'Arizona (AZ)',
    value: 'Arizona'
  },
  {
    label: 'Arkansas (AR)',
    value: 'Arkansas'
  },
  {
    label: 'California (CA)',
    value: 'California'
  },
  {
    label: 'Colorado (CO)',
    value: 'Colorado'
  },
  {
    label: 'Connecticut (CT)',
    value: 'Connecticut'
  },
  {
    label: 'Delaware (DE)',
    value: 'Delaware'
  },
  {
    label: 'District of Columbia (DC)',
    value: 'District of Columbia'
  },
  {
    label: 'Florida (FL)',
    value: 'Florida'
  },
  {
    label: 'Georgia (GA)',
    value: 'Georgia'
  },
  {
    label: 'Hawaii (HI)',
    value: 'Hawaii'
  },
  {
    label: 'Idaho (ID)',
    value: 'Idaho'
  },
  {
    label: 'Illinois (IL)',
    value: 'Illinois'
  },
  {
    label: 'Indiana (IN)',
    value: 'Indiana'
  },
  {
    label: 'Iowa (IA)',
    value: 'Iowa'
  },
  {
    label: 'Kansas (KS)',
    value: 'Kansas'
  },
  {
    label: 'Kentucky (KY)',
    value: 'Kentucky'
  },
  {
    label: 'Louisiana (LA)',
    value: 'Louisiana'
  },
  {
    label: 'Maine (ME)',
    value: 'Maine'
  },
  {
    label: 'Maryland (MD)',
    value: 'Maryland'
  },
  {
    label: 'Massachusetts (MA)',
    value: 'Massachusetts'
  },
  {
    label: 'Michigan (MI)',
    value: 'Michigan'
  },
  {
    label: 'Minnesota (MN)',
    value: 'Minnesota'
  },
  {
    label: 'Mississippi (MS)',
    value: 'Mississippi'
  },
  {
    label: 'Missouri (MO)',
    value: 'Missouri'
  },
  {
    label: 'Montana (MT)',
    value: 'Montana'
  },
  {
    label: 'Nebraska (NE)',
    value: 'Nebraska'
  },
  {
    label: 'Nevada (NV)',
    value: 'Nevada'
  },
  {
    label: 'New Hampshire (NH)',
    value: 'New Hampshire'
  },
  {
    label: 'New Jersey (NJ)',
    value: 'New Jersey'
  },
  {
    label: 'New Mexico (NM)',
    value: 'New Mexico'
  },
  {
    label: 'New York (NY)',
    value: 'New York'
  },
  {
    label: 'North Carolina (NC)',
    value: 'North Carolina'
  },
  {
    label: 'North Dakota (ND)',
    value: 'North Dakota'
  },
  {
    label: 'Ohio (OH)',
    value: 'Ohio'
  },
  {
    label: 'Oklahoma (OK)',
    value: 'Oklahoma'
  },
  {
    label: 'Oregon (OR)',
    value: 'Oregon'
  },
  {
    label: 'Pennsylvania (PA)',
    value: 'Pennsylvania'
  },
  {
    label: 'Puerto Rico (PR)',
    value: 'Puerto Rico'
  },
  {
    label: 'Rhode Island (RI)',
    value: 'Rhode Island'
  },
  {
    label: 'South Carolina (SC)',
    value: 'South Carolina'
  },
  {
    label: 'South Dakota (SD)',
    value: 'South Dakota'
  },
  {
    label: 'Tennessee (TN)',
    value: 'Tennessee'
  },
  {
    label: 'Texas (TX)',
    value: 'Texas'
  },
  {
    label: 'Utah (UT)',
    value: 'Utah'
  },
  {
    label: 'Vermont (VT)',
    value: 'Vermont'
  },
  {
    label: 'Virginia (VA)',
    value: 'Virginia'
  },
  {
    label: 'Washington (WA)',
    value: 'Washington'
  },
  {
    label: 'West Virginia (WV)',
    value: 'West Virginia'
  },
  {
    label: 'Wisconsin (WI)',
    value: 'Wisconsin'
  },
  {
    label: 'Wyoming (WY)',
    value: 'Wyoming'
  }
]

/* const categories = [
  {
    label: 'Beverages',
    value: 'Beverages'
  },
  {
    label: 'Bread and Bakery',
    value: 'Bread and Bakery'
  },
  {
    label: 'Dairy and Eggs',
    value: 'Dairy and Eggs'
  },
  {
    label: 'Deli',
    value: 'Deli'
  },
  {
    label: 'Frozen',
    value: 'Frozen'
  },
  {
    label: 'Meat',
    value: 'Meat'
  },
  {
    label: 'Miscellaneous ',
    value: 'Miscellaneous'
  },
  {
    label: 'Pantry',
    value: 'Pantry'
  },
  {
    label: 'Prepared Foods',
    value: 'Prepared Foods'
  },
  {
    label: 'Produce',
    value: 'Produce'
  },
  {
    label: 'Seafood',
    value: 'Seafood'
  }
] */

const Option = props => {
  return (
    <div>
      <components.Option {...props}>
        <Checkbox checked={props.isSelected} onChange={() => null} flip label={props.label} />
      </components.Option>
    </div>
  )
}

const MultiValue = props => (
  <components.MultiValue {...props}>
    <span>{props.data.label}</span>
  </components.MultiValue>
)

class AddRecallWarning extends Component {
  state = {
    loader: false,
    selectedOption: [],
    selectedLocationOption: [],
    users: [],
    selectedUserOption: null,
    selectedTypeOption: null,
    selectedActiveOption: null,
    warningData: [],
    newsDate: new Date(),
    showProductModal: false,
    productDetail: {},
    productList: [],
    optionSelectedCheckbox: [],
    selectedNotificationOption: null,
    searchBy: 'productName',
    updateUpc: false,
    categories: []
  }
  componentDidMount() {
    // this.getUsers()
    this.fetchCategories()
    if (get(this.props.match, 'params.id', '')) {
      this.getRecallWarningById()
    }
  }

  fetchCategories = async () => {
    try {
      const { data } = await axios.get(`${API_URL}/Categories`)
      const categories = data.map(item => ({
        label: item.name,
        value: item.name
      }))
      this.setState({
        categories
      })
    } catch (error) {
      console.log(error)
    }
  }

  getRecallWarningById = async () => {
    const id = get(this.props.match, 'params.id', '')
    try {
      const { data } = await axios.get(`${API_URL}/RecallWarnings/${id}`)
      let cates = get(data, 'categories', '') ? get(data, 'categories', '').split(',') : []
      cates = cates.map(item => ({
        label: item,
        value: item
      }))

      const optionTypes = { value: get(data, 'type', null), label: get(data, 'type', null) }
      const optionActive = { value: get(data, 'isActive', false), label: get(data, 'isActive', false) ? 'Yes' : 'No' }

      this.setState({
        warningData: data,
        selectedOption: cates,
        selectedTypeOption: optionTypes,
        selectedActiveOption: optionActive
      })
    } catch (error) {
      console.log(error)
    }
  }
  handleChange = selectedOption => {
    this.setState({ selectedOption })
  }

  handleChangeCheckbox = optionSelectedCheckbox => {
    this.setState({ optionSelectedCheckbox })
  }

  handleChangeLocation = selectedLocationOption => {
    this.setState({ selectedLocationOption })
  }

  handleChangeType = selectedTypeOption => {
    this.setState({ selectedTypeOption })
  }

  handleChangeActive = selectedActiveOption => {
    this.setState({ selectedActiveOption })
  }

  handleChangeNotification = selectedNotificationOption => {
    this.setState({ selectedNotificationOption })
  }

  handleChangeDate = date => {
    this.setState({
      newsDate: date
    })
  }

  async fetchAsyncProductsData(value) {
    if (value) {
      try {
        if (this.state.searchBy === 'productName') {
          const { data } = await axios.post(`${API_URL}/producttablemergeds/getProductsBySearch`, {
            searchTerm: value,
            filters: [],
            offset: 0,
            limit: 50
          })
          this.setState({ products: data })
        } else {
          const query = {
            filter: {
              where: {
                upcCode: value
              }
            }
          }
          const { data } = await axios.get(`${API_URL}/ProductTableMergeds`, { params: { filter: query.filter } })
          this.setState({ products: data })
        }
      } catch (error) {
        console.log('ERROR', error)
      }
    }
    return this.state.products
  }

  loadProducts = async inputValue => {
    try {
      let newData = []
      newData = await this.fetchAsyncProductsData(inputValue)
      return newData.map(item => ({
        value: item.productCode,
        label: `${item.productName}`,
        productsData: item
      }))
    } catch (err) {
      console.log(err)
    }
  }

  addProduct = () => {
    const productDetail = {
      productName: get(this.state.productDetail, 'label', ''),
      productCode: get(this.state.productDetail, 'value', '')
    }
    this.setState({
      productList: uniqBy([...this.state.productList, productDetail], 'productCode'),
      showProductModal: false
    })
  }

  omitProducts = productCode => {
    const newProds = this.state.productList.filter(item => item.productCode !== productCode)
    this.setState({
      productList: newProds
    })
  }

  render() {
    const {
      selectedOption,
      isLoading,
      warningData,
      selectedTypeOption,
      selectedActiveOption,
      newsDate,
      showProductModal,
      optionSelectedCheckbox,
      selectedNotificationOption,
      searchBy,
      categories
    } = this.state
    return (
      <React.Fragment>
        <Header
          icon="arrowBack"
          title={get(this.props.match, 'params.id', '') ? 'Edit Recall Warning' : 'Add Recall Warning'}
          onClickBack={() => this.props.history.goBack()}
          backgroundColor="#124b5f"
          color="#fff"
        />
        <PageWrapper viewPadding="0 20px" height={'calc(100% - 0px)'} modifyPadding="0 20px" style={{ paddingTop: 60 }}>
          <Formik
            enableReinitialize
            initialValues={{
              title: get(warningData, 'title', '') || '',
              newsSource: get(warningData, 'newsSource', '') || '',
              url: get(warningData, 'url', '') || ''
            }}
            onSubmit={async (val, { resetForm }) => {
              this.setState({ isLoading: true })
              const cates =
                this.state.selectedOption.length > 0
                  ? get(this.state, 'selectedOption', [])
                      .map(item => item.value)
                      .join(',')
                  : null
              const prods =
                this.state.productList.length > 0
                  ? this.state.productList.map(item => item.productCode).join(',')
                  : null
              const prodNames =
                this.state.productList.length > 0
                  ? this.state.productList.map(item => item.productName).join('||')
                  : null
              const locs =
                this.state.optionSelectedCheckbox.length > 0
                  ? this.state.optionSelectedCheckbox.map(item => item.value).join(',')
                  : null
              await axios.post(`${API_URL}/RecallWarnings`, {
                title: get(val, 'title', null),
                newsSource: get(val, 'newsSource', null),
                newsDate: get(this.state, 'newsDate', null),
                url: get(val, 'url', null),
                categories: cates,
                products: prods,
                productNames: prodNames,
                locations: locs,
                type: get(this.state, 'selectedTypeOption.value', 'Category'),
                isActive: get(this.state, 'selectedActiveOption.value', false),
                notification: get(this.state, 'selectedNotificationOption.value', false),
                publishDate: new Date()
              })
              resetForm()
              this.setState({
                isLoading: false,
                selectedTypeOption: null,
                selectedActiveOption: null,
                selectedNotificationOption: null,
                optionSelectedCheckbox: [],
                selectedOption: [],
                productList: []
              })
            }}
            render={formikBag => (
              <FormikForm
                style={{
                  justifyContent: 'space-between',
                  overflowX: 'scroll',
                  padding: '0 20px',
                  border: '2px solid'
                }}>
                <XXLText style={{ marginTop: 30 }}>Recall Warning</XXLText>
                <Field
                  name="title"
                  render={({ field }) => (
                    <TextField
                      {...field}
                      type="text"
                      label="Title"
                      margin="30px 14px"
                      width="auto"
                      required
                      fontSize="18px"
                      fontColor="#124b5f"
                    />
                  )}
                />
                <Field
                  name="newsSource"
                  render={({ field }) => (
                    <TextField
                      {...field}
                      type="text"
                      label="News Source"
                      margin="30px 14px"
                      width="auto"
                      required
                      fontSize="18px"
                      fontColor="#124b5f"
                    />
                  )}
                />
                <Datepicker
                  label="Date"
                  value={moment(newsDate).format('DD MMM YYYY')}
                  selected={newsDate}
                  onChange={this.handleChangeDate}
                />
                <div>
                  <Field
                    name="url"
                    render={({ field }) => (
                      <TextArea
                        {...field}
                        type="text"
                        height="68px"
                        viewPadding="10px 10px 30px 10px"
                        placeholder="Link"
                        paddingTop="30px"
                        fontColor="#124b5f"
                        required
                      />
                    )}
                  />
                </div>
                <Field
                  name="type"
                  render={({ field }) => (
                    <SelectBox
                      name="type"
                      label="Select Type"
                      required
                      placeholder="Select Type"
                      options={[{ value: 'Category', label: 'Category' }, { value: 'Product', label: 'Product' }]}
                      value={selectedTypeOption}
                      onChange={this.handleChangeType}
                      selectField
                    />
                  )}
                />
                {get(selectedTypeOption, 'value', '') === 'Product' ? (
                  <div>
                    <FlexWrapper direction="direction">
                      <div style={{ marginBottom: 20, padding: '0 10px' }}>
                        <Radio
                          name="searchBy"
                          value="productName"
                          checked={searchBy === 'productName'}
                          label="Search via product name"
                          onChange={obj => this.setState({ searchBy: obj })}
                        />
                        <Radio
                          name="searchBy"
                          value="upcCode"
                          label="Search via upc code"
                          checked={searchBy === 'upcCode'}
                          onChange={obj => this.setState({ searchBy: obj })}
                        />
                      </div>
                    </FlexWrapper>
                  </div>
                ) : null}
                <div>
                  {get(selectedTypeOption, 'value', '') === 'Product' ? (
                    <FlexWrapper>
                      <Field
                        name="product"
                        render={({ field }) => (
                          <SelectBox
                            cacheOptions
                            isClearable={true}
                            defaultOptions={true}
                            loadOptions={this.loadProducts}
                            isSelected
                            placeholder="Search Product"
                            onChange={product => {
                              if (product) {
                                this.setState({ productDetail: product, showProductModal: true })
                              }
                            }}
                          />
                        )}
                      />
                      <div style={{ width: '100%', padding: '0 10px', marginBottom: '30px' }}>
                        <FlexWrapper
                          viewPadding="20px 20px"
                          style={{
                            background: '#fbf8f1',
                            borderRadius: '5px',
                            boxShadow: '0 2px 4px 0 rgba(0,0,0,0.16)'
                          }}>
                          <DefaultText
                            padding="0 0 4px 0"
                            color="#124b5f"
                            style={{
                              display: 'block',
                              borderBottom: '1px solid #124b5f',
                              width: '100%',
                              marginBottom: '4px'
                            }}>
                            Product List
                          </DefaultText>

                          {this.state.productList.length > 0
                            ? this.state.productList.map(item => (
                                <FlexWrapper
                                  alignItems="center"
                                  viewPadding="10px 0 6px 0"
                                  style={{ borderBottom: '1px solid #ccc' }}
                                  direction="row"
                                  justifyContent="space-between">
                                  <DefaultText style={{ fontSize: 15 }}>{item.productName}</DefaultText>
                                  <Close onClick={() => this.omitProducts(item.productCode)}>X</Close>
                                </FlexWrapper>
                              ))
                            : null}
                        </FlexWrapper>
                      </div>
                    </FlexWrapper>
                  ) : null}
                </div>
                <Field
                  name="cat"
                  render={({ field }) => (
                    <SelectBox
                      isMulti={true}
                      closeMenuOnSelect={false}
                      name="cat"
                      label="Users"
                      placeholder="Select Categories"
                      options={categories}
                      value={selectedOption}
                      onChange={this.handleChange}
                      selectField
                    />
                  )}
                />
                <Field
                  name="loc"
                  render={({ field }) => (
                    <MySelectCheckbox
                      isMulti={true}
                      closeMenuOnSelect={false}
                      name="loc"
                      label="Users"
                      placeholder="Select Locations"
                      options={usStates}
                      value={optionSelectedCheckbox}
                      onChange={this.handleChangeCheckbox}
                      selectField
                      components={{ Option, MultiValue }}
                      allowSelectAll={true}
                    />
                  )}
                />
                <Field
                  name="active"
                  render={({ field }) => (
                    <SelectBox
                      name="active"
                      label="Select Status"
                      placeholder="Select Status"
                      options={[{ value: 1, label: 'Live' }, { value: 0, label: 'Dead' }]}
                      value={selectedActiveOption}
                      onChange={this.handleChangeActive}
                      selectField
                    />
                  )}
                />
                <Field
                  name="notification"
                  render={({ field }) => (
                    <SelectBox
                      name="notification"
                      label="Do you want to send Notification"
                      placeholder="Do you want to send Notification"
                      options={[{ value: 1, label: 'Yes' }, { value: 0, label: 'No' }]}
                      value={selectedNotificationOption}
                      onChange={this.handleChangeNotification}
                      selectField
                    />
                  )}
                />
                <div>
                  <Button
                    style={{ lineHeight: 2.4, marginBottom: 20 }}
                    volume="filled"
                    type="submit"
                    label="Submit"
                    disabled={isLoading}
                    isLoading={isLoading}
                  />
                </div>
              </FormikForm>
            )}
          />
        </PageWrapper>
        <Modal
          title={'Product'}
          show={showProductModal}
          hide={!showProductModal}
          maxWidth="648px"
          onClose={() => this.setState({ showProductModal: false })}>
          <React.Fragment>
            <FlexWrapper direction="row">
              <StyledImage
                margin="0 20px"
                src={
                  get(this.state.productDetail, 'productsData.productImage', '')
                    ? get(this.state.productDetail, 'productsData.productImage', '')
                    : require('../static/images/no-image.png')
                }
                height="204px"
                alt="Product Image"
              />
              <div>
                <DefaultText padding="0 0 10px 0">
                  <span
                    style={{
                      width: '100%',
                      fontSize: '12px',
                      textTransform: 'uppercase',
                      display: 'block',
                      color: '#b1b1b1'
                    }}>
                    Product Name{' '}
                  </span>
                  {get(this.state.productDetail, 'label', '')}
                </DefaultText>
                <DefaultText padding="0 0 10px 0">
                  <span
                    style={{
                      width: '100%',
                      fontSize: '12px',
                      textTransform: 'uppercase',
                      display: 'block',
                      color: '#b1b1b1'
                    }}>
                    Product Code{' '}
                  </span>
                  {get(this.state.productDetail, 'value', '')}
                </DefaultText>

                <DefaultText padding="0 0 10px 0">
                  <span
                    style={{
                      width: '100%',
                      fontSize: '12px',
                      textTransform: 'uppercase',
                      display: 'block',
                      color: '#b1b1b1'
                    }}>
                    Ingredient{' '}
                  </span>
                  {get(this.state.productDetail, 'productsData.ingredientList', '')}
                </DefaultText>
                <DefaultText padding="0 0 10px 0">
                  <span
                    style={{
                      width: '100%',
                      fontSize: '12px',
                      textTransform: 'uppercase',
                      display: 'block',
                      color: '#b1b1b1'
                    }}>
                    Category{' '}
                  </span>
                  {get(this.state.productDetail, 'productsData.productCategory', '')}
                </DefaultText>
                <DefaultText padding="0 0 10px 0">
                  <span
                    style={{
                      width: '100%',
                      fontSize: '12px',
                      textTransform: 'uppercase',
                      display: 'block',
                      color: '#b1b1b1'
                    }}>
                    UPC Code{' '}
                  </span>
                  {get(this.state.productDetail, 'productsData.upcCode', '')}
                </DefaultText>
                <FlexWrapper direction="direction">
                  <div style={{ marginBottom: 20 }}>
                    <Checkbox
                      borderColor="#078489"
                      flip
                      labelStyle="#078489"
                      label="Update UPC Code"
                      onChange={checked => this.setState({ updateUpc: checked })}
                    />
                  </div>
                </FlexWrapper>
                <Button
                  size="small"
                  volume="filled"
                  padding="10px 20px"
                  height="42px"
                  fontSize="15px"
                  type="button"
                  label="Add Product"
                  disabled={this.state.isLoading}
                  isLoading={this.state.isLoading}
                  onClick={this.addProduct}
                />
              </div>
            </FlexWrapper>
            {this.state.updateUpc ? (
              <Formik
                enableReinitialize
                initialValues={{ upcCode: '', confirmUpcCode: '' }}
                validateOnChange
                validate={changeUpcValidator}
                onSubmit={async val => {
                  this.setState({ isLoading: true })
                  await axios.patch(
                    `${API_URL}/ProductTableMergeds/${get(this.state.productDetail, 'productsData.productCode', '')}`,
                    {
                      upcCode: val.upcCode
                    }
                  )
                  this.setState({ isLoading: false })
                }}
                render={formikBag => (
                  <FormikForm>
                    <Field
                      name="upcCode"
                      render={({ field }) => (
                        <FlexWrapper height="100%">
                          <Field
                            name="upcCode"
                            render={({ field }) => (
                              <TextField
                                {...field}
                                width="calc(100% - 40px)"
                                paddingTop="10px"
                                type="text"
                                fontColor="#124b5f"
                                viewPadding="10px 14px 0"
                                hideEye
                                label="Enter Upc Code"
                                margin="30px 0"
                                fontSize="18px"
                                required
                                error={formikBag.errors.upcCode}
                              />
                            )}
                          />
                          <Field
                            name="confirmUpcCode"
                            render={({ field }) => (
                              <TextField
                                {...field}
                                type="text"
                                width="calc(100% - 40px)"
                                paddingTop="10px"
                                fontColor="#124b5f"
                                viewPadding="10px 14px 0"
                                hideEye
                                label="Confirm Upc Code"
                                margin="30px 0"
                                fontSize="18px"
                                required
                                error={formikBag.errors.confirmUpcCode}
                              />
                            )}
                          />
                        </FlexWrapper>
                      )}
                    />

                    <Button
                      padding="10px 20px"
                      height="42px"
                      fontSize="15px"
                      size="small"
                      volume="filled"
                      type="submit"
                      label="Submit"
                      disabled={this.state.isLoading}
                      isLoading={this.state.isLoading}
                    />
                  </FormikForm>
                )}
              />
            ) : null}
          </React.Fragment>
        </Modal>
      </React.Fragment>
    )
  }
}
export default AddRecallWarning



// WEBPACK FOOTER //
// ./src/pages/AddRecallWarning.js